import {ActionIcon, Tooltip} from "@mantine/core";
import {notifications} from "@mantine/notifications";
import {useTranslation} from "react-i18next";
import {dibAppApi} from "../../dibAppApi/dibAppApi";
import IconPin from "../../assets/pin.svg?react";
import IconPinFilled from "../../assets/pin-filled.svg?react";

export const FavoriteTopicButton = ({topicId}: {topicId: string}) => {
    const {t} = useTranslation();
    const {data: favorites} = dibAppApi.endpoints.getFavorites.useQuery();
    const [patchFollow] = dibAppApi.endpoints.patchDocumentFollow.useMutation();
    const [deleteFollow] =
        dibAppApi.endpoints.deleteDocumentFollow.useMutation();

    // No button until the favorites set is known — rendering a default
    // (outline) state first would flash wrong for already-favorited topics.
    if (!favorites) return null;

    // URL guids are lowercase while API item ids may not be.
    const isFavorite = favorites.items.some(
        (item) => item.id?.toLowerCase() === topicId.toLowerCase()
    );

    const label = isFavorite
        ? t("Content.removeFromFavorites", {
              defaultValue: "Remove from favorites",
          })
        : t("Content.addToFavorites", {defaultValue: "Add to favorites"});

    const handleClick = () => {
        const mutation = isFavorite ? deleteFollow : patchFollow;
        mutation({topicId})
            .unwrap()
            .catch(() => {
                notifications.show({
                    message: t("Error.SomethingWentWrong"),
                    color: "red",
                });
            });
    };

    return (
        <Tooltip label={label}>
            <ActionIcon
                size="lg"
                radius="xl"
                variant="subtle"
                color="gneis"
                aria-label={label}
                onClick={handleClick}
            >
                {isFavorite ? (
                    <IconPinFilled
                        color="var(--dib-brand-base)"
                        width={20}
                        height={20}
                    />
                ) : (
                    <IconPin width={20} height={20} />
                )}
            </ActionIcon>
        </Tooltip>
    );
};
